export default __webpack_public_path__ + "static/children-cheering-8c40d927937830a30e9c9221672c886d.mp3";